import { render, staticRenderFns } from "./GadgetDetails.vue?vue&type=template&id=6cfcccd6&"
import script from "./GadgetDetails.vue?vue&type=script&lang=js&"
export * from "./GadgetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports